import axios from 'axios';

import { RAGFLOW_API_KEY, RAGFLOW_BASE_URL } from './env';

const axiosRagflow = axios.create({
	baseURL: RAGFLOW_BASE_URL,
	headers: {
		Authorization: `Bearer ${RAGFLOW_API_KEY}`,
	},
});

export default axiosRagflow;
